import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-add-subfranchise',
  templateUrl: './add-subfranchise.component.html',
  styleUrls: ['./add-subfranchise.component.css']
})
export class AddSubfranchiseComponent implements OnInit {

    staffData = {
      name: '',
      email: '',
      mobile: '',
      city: '',
      district: '',
      type:'subfranchise'
    };
    constructor(public activeModal: NgbActiveModal) { }
  
    ngOnInit(): void {
    }
    submitForm() {
      this.activeModal.close(this.staffData);
    }
    onClose(): void {
      this.activeModal.dismiss('Modal closed'); 
    }
  }
  
